import { createContext, useContext } from "react";

/**
 * What the screens know about the person using them, beyond being signed in.
 *
 * Only what decides which controls to offer. The API makes the real decision
 * on every request; this is so a screen does not offer a button whose only
 * answer is 403.
 */
export interface CurrentUser {
  readonly isAdmin: boolean;
}

/**
 * Until `/me` has answered — and anywhere no provider was set up — nobody is
 * an administrator. Showing the controls a moment late is better than showing
 * them to somebody who cannot use them.
 */
const NOT_YET_KNOWN: CurrentUser = { isAdmin: false };

const CurrentUserContext = createContext<CurrentUser>(NOT_YET_KNOWN);

export const CurrentUserProvider = CurrentUserContext.Provider;

export function useCurrentUser(): CurrentUser {
  return useContext(CurrentUserContext);
}
